module.exports = __webpack_public_path__ + "img/login-bg-8.9cda0055.jpg";